/**
 * Função para converter inscritos formatados em número
 * Suporta formatos em português como "2 mi de inscritos", "1,5 milhão", "500 mil", etc.
 * 
 * @param {string} subscribersText - Texto formatado dos inscritos
 * @returns {number} - Número de inscritos como inteiro
 */
export const parseSubscribers = (subscribersText) => {
  if (!subscribersText) return 0;
  
  // Se já é um número, retorna diretamente
  if (typeof subscribersText === 'number') {
    return Math.round(subscribersText);
  }
  
  // Remove espaços e converte para minúsculo
  const cleanText = subscribersText.toString().toLowerCase().replace(/\s/g, '');
  
  console.log('🔍 Parsing subscribers:', { original: subscribersText, clean: cleanText });
  
  // Padrões mais abrangentes para português
  // IMPORTANTE: A ordem importa! Mais específicos primeiro
  const patterns = [
    // "1,5 milhão" ou "1.5 milhões" (milhões por extenso)
    /(\d+(?:[.,]\d+)?)\s*(?:milhão|milhões)/,
    // "500 mil" (mil por extenso - deve vir ANTES de "mi")
    /(\d+(?:[.,]\d+)?)\s*mil(?!\S)/,
    // "2 mi de inscritos" ou "2mi" (mi como abreviação - usa negative lookahead para não pegar "mil")
    /(\d+(?:[.,]\d+)?)\s*mi(?:l)?(?:\s|$)/,
    // "500k" (abreviação inglesa)
    /(\d+(?:[.,]\d+)?)\s*k(?!\S)/,
    // "1000" (número direto)
    /(\d+(?:[.,]\d+)?)/
  ];
  
  for (const pattern of patterns) {
    const match = cleanText.match(pattern);
    if (match) {
      const number = parseFloat(match[1].replace(',', '.'));
      const fullMatch = match[0];
      
      console.log('✅ Match found:', { fullMatch, number });
      
      // Determina a unidade baseada no texto completo
      // IMPORTANTE: Verificar "mil" ANTES de "mi" para evitar confusão
      if (fullMatch.includes('milhão') || fullMatch.includes('milhões')) {
        console.log('🔢 Detectado: MILHÕES');
        return Math.round(number * 1000000);
      } else if (fullMatch.includes('mil')) {
        console.log('🔢 Detectado: MIL');
        return Math.round(number * 1000);
      } else if (fullMatch.includes('mi') && !fullMatch.includes('mil')) {
        console.log('🔢 Detectado: MI (milhões)');
        return Math.round(number * 1000000);
      } else if (fullMatch.includes('k')) {
        console.log('🔢 Detectado: K (mil)');
        return Math.round(number * 1000);
      } else {
        console.log('🔢 Detectado: NÚMERO DIRETO');
        return Math.round(number);
      }
    }
  }
  
  console.log('❌ No pattern matched for:', cleanText);
  return 0;
};

/**
 * Função para calcular tier baseado no número de inscritos
 * 
 * @param {number} subscribers - Número de inscritos
 * @returns {object} - { tier: string, color: string }
 */
export const calculateYouTubeTier = (subscribers) => {
  if (subscribers >= 1000000) {
    return { tier: 'Tier 1', color: 'success' };
  } else if (subscribers >= 100000) {
    return { tier: 'Tier 2', color: 'warning' };
  } else if (subscribers >= 10000) {
    return { tier: 'Tier 3', color: 'info' };
  } else {
    return { tier: 'Tier 4', color: 'default' };
  }
};

/**
 * Função para formatar número de inscritos para exibição
 * 
 * @param {number} subscribers - Número de inscritos
 * @returns {string} - Número formatado (ex: "2.300.000", "114.000")
 */
export const formatSubscribers = (subscribers) => {
  // Formata o número com separador de milhares (ex: 114.000, 2.300.000)
  return subscribers.toLocaleString('pt-BR');
};
